/* eslint-disable no-loop-func */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { pdfjs } from "react-pdf";
import { motion, AnimatePresence } from "framer-motion";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// const API_URL = "http://localhost:8000/snow_chat_stream";
// const Suggest_API_URL = "http://localhost:8000/snow_suggest";
const API_URL = "https://api.zenopsai.net/zenbot/snow_chat_stream";
const Suggest_API_URL = "https://api.zenopsai.net/zenbot/snow_suggest";

const ChatBot = () => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [answersMap, setAnswersMap] = useState({});
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [loadingSuggest, setLoadingSuggest] = useState(false);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [isSuggest, setSuggest] = useState(false);
  const [messageType, setMessageType] = useState(false);
  const debounceTimer = useRef(null);
  const scrollRef = useRef(null);
  const lastQuery = useRef("");
  const threadIdRef = useRef(null);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);
  const [thoughtProcessHtml, setThoughtProcessHtml] = useState(null);
   let userId = useRef(
    Date.now().toString(36) + Math.random().toString(36).substring(2, 10)
  );
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    scrollToBottom();
  }, [messages, answersMap]);
  const scrollToBottom = () => {
    try {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    } catch (err) {
      console.error("Scroll to bottom error:", err);
    }
  };
  useEffect(() => {
    function handleMessage(event) {
      const allowedOrigins = [
        window.location.origin,
        "http://localhost:3000",
        "https://dev347077.service-now.com",
        "https://snowrecommendations.azurewebsites.net",
      ];
      if (!allowedOrigins.includes(event.origin)) return;
      if (event.data.action === "live_suggestion") {
        setAnswersMap({});
        setMessageType(true);
        const query = event.data.query.trim();
        if (lastQuery.current === query) return;
        const wordCount = query.split(/\s+/).length;

        if (wordCount < 3) return;
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }

        // debounceTimer.current = setTimeout(() => {
        setUserInput(query);
        sendMessage(query);
        fetchSuggestions(query);
        lastQuery.current = query;
        // eslint-disable-next-line react-hooks/exhaustive-deps, no-const-assign
        userId = Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
        // fetch(`${Suggest_API_URL}?partial_input=${encodeURIComponent(query)}`)
        //   .then(res => res.json())
        //   .then(data => {
        //     setSuggestions(data.suggestions || []);
        //   })
        // .catch(err => console.error(err));
        // }, 0); // adjust delay as needed
      }
    }

    window.addEventListener("message", handleMessage);

    setTimeout(() => {
      window.parent.postMessage("zen_ready", "*");
      console.log("parent is ready", window.location.origin);
    }, 1500);

    return () => {
      window.removeEventListener("message", handleMessage);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSuggestions = async (text, suggestMode = isSuggest) => {
    if (!text || text.trim().split(/\s+/).length < 3) {
      setSuggestions([]);
      setLoadingSuggest(false);
      return;
    }

    if (suggestMode) {
      return;
    } else {
      try {
        setLoadingSuggest(true);
        setAnswersMap({});
        setSuggestions([]);
        setSelectedSuggestion(null);
        setSuggest(false)
        const res = await fetch(
          `${Suggest_API_URL}?partial_input=${encodeURIComponent(text)}`
        );
        if (!res.ok) throw new Error("Failed to fetch suggestions");
        const data = await res.json();
        setSuggestions(data.suggestions || []);
      } catch (err) {
        console.error("Suggestion API error:", err);
      } finally {
        setLoadingSuggest(false);
      }
    }
  };
  const closeSidebar = () => {
    setSelectedPdfUrl(null);
    setThoughtProcessHtml(null);
  };
  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };
  useEffect(() => {
    const clickHandler = (e) => {
      const link = e.target.closest("a[href]");
      if (!link) return;

      if (link.getAttribute("href").toLowerCase().includes(".pdf")) {
        e.preventDefault();
        let href = link.getAttribute("href")?.replace(/#page(\d+)/, "#page=$1");
        if (!href.startsWith("http")) {
          href = `${window.location.origin}${href}`;
        }

        setSelectedPdfUrl(href);
      }
    };

    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchSuggestions = useCallback(
    debounce(fetchSuggestions, 800),
    []
  );

  useEffect(() => {
    if (!isSuggest && userInput.trim()) {
      debouncedFetchSuggestions(userInput, false);
    }
  }, [userInput, isSuggest, debouncedFetchSuggestions]);

  const buildHistoryFromThread = (thread) => (thread || []).map((m) => m.text);

  const streamChatReply = async (message, threadIndex) => {
    try {
      setLoadingIndex(threadIndex);
      const history = buildHistoryFromThread(answersMap[threadIndex]);
      const user_id=userId.current;
      const thread_id = threadIdRef.current;
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message,user_id,thread_id, history }),
      });

      if (!res.body) throw new Error("No response body");

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const parts = buffer.split("\n\n");
        buffer = parts.pop();

        for (const part of parts) {
          if (!part.startsWith("data:")) continue;

          try {
            let raw = part.replace(/^data:\s*/, "");
            raw = raw.replace(/[\r\n]+/g, "\\n");

            const json = JSON.parse(raw);
            if (json.type === "answer_chunk") {
              const chunk = json.text;
              const cleanChunk = chunk.replace(/\*\*/g, "");
              setAnswersMap((prev) => {
                const existing = prev[threadIndex] || [];
                const last = existing[existing.length - 1];

                if (last && last.sender === "bot") {
                  const updated = [
                    ...existing.slice(0, -1),
                    {
                      ...last,
                      text: (last.text || "") + cleanChunk,
                    },
                  ];
                  return { ...prev, [threadIndex]: updated };
                }

                return {
                  ...prev,
                  [threadIndex]: [
                    ...existing,
                    { sender: "bot", text: cleanChunk, meta: {} },
                  ],
                };
              });
            }

            if (json.type === "sources") {
              setAnswersMap((prev) => {
                const existing = prev[threadIndex] || [];
                const last = existing[existing.length - 1];

                if (last && last.sender === "bot") {
                  const updated = [
                    ...existing.slice(0, -1),
                    {
                      ...last,
                      meta: { ...last.meta, sources: json.sources },
                    },
                  ];
                  return { ...prev, [threadIndex]: updated };
                }
                return prev;
              });
            }
             
            if(json.type === "thread_id"){
              threadIdRef.current = json.thread_id;
               setAnswersMap((prev) => {
                const existing = prev[threadIndex] || [];
                const last = existing[existing.length - 1];

                if (last && last.sender === "bot") {
                  
                  const updated = [
                    ...existing.slice(0, -1),
                    {
                      ...last,
                      meta: { ...last.meta, thread_id: json.thread_id },
                    },
                  ];
                  return { ...prev, [threadIndex]: updated };
                }
                return prev;
              });
            }

            if (json.type === "groundedness") {
              setAnswersMap((prev) => {
                const existing = prev[threadIndex] || [];
                const last = existing[existing.length - 1];

                if (last && last.sender === "bot") {
                  const updated = [
                    ...existing.slice(0, -1),
                    {
                      ...last,
                      meta: { ...last.meta, groundedness: json.score },
                    },
                  ];
                  return { ...prev, [threadIndex]: updated };
                }
                return prev;
              });
            }

            if (json.type === "answer_complete") {
              console.log("Answer finished ✅");
            }
          } catch (e) {
            console.error("Failed to parse SSE JSON:", part, e);
          }
        }
      }
    } catch (err) {
      console.error("Streaming error:", err);
      setAnswersMap((prev) => ({
        ...prev,
        [threadIndex]: [
          ...(prev[threadIndex] || []),
          { sender: "bot", text: "❌ Failed to fetch answer" },
        ],
      }));
    } finally {
      setLoadingIndex(null);
    }
  };

  const toggleDropdown = async (index) => {
    setMessageType(false);
    setSuggest(true);
    setUserInput("");
    setSelectedSuggestion(index);
    if (answersMap[index]?.length) return;

    const prompt = suggestions[index];

    setAnswersMap((prev) => ({
      ...prev,
      [index]: [{ sender: "user", text: prompt }],
    }));

    await streamChatReply(prompt, index);
  };

  const sendMessage = async () => {
    const text = (userInput || "").trim();
    if (!text) return;
    if (selectedSuggestion == null) {
      return;
    }

    const threadIndex = selectedSuggestion;

    setAnswersMap((prev) => ({
      ...prev,
      [threadIndex]: [...(prev[threadIndex] || []), { sender: "user", text }],
    }));

    setMessages((msgs) => [...msgs, { sender: "user", text }]);
    setUserInput("");

    await streamChatReply(text, threadIndex);
  };

  const renderMessageHtml = (text) => {
    if (!text || typeof text !== "string") return "";
    return text.replace(/(\S+\.pdf),page:(\d+)/g, (m, file, page) => {
      return `<a href="${file}#page=${page}" target="_blank" rel="noreferrer">${file} (page ${page})</a>`;
    });
  };
  const sidebarVisible = selectedPdfUrl || thoughtProcessHtml;
  return (
    <div className="m-0" style={{ display: "flex", background: "#dad9dc" }}>
      <div
        className="row m-0"
        style={{ width: "100%", gap: "10px", minHeight: "395px" }}
      >
        <div className="card col p-0">
          <div className="card-header">ZenAssist-Recommendations</div>
          {suggestions.length === 0 &&
            !loadingSuggest &&
            selectedSuggestion === null && (
              <div
                className="card-body"
                style={{ alignSelf: "center", alignContent: "center" }}
              >
                <span>
                  <img
                    src="/pana.svg"
                    width={200}
                    alt="No Active Recommenedations"
                  />
                </span>
                <h5 className="text-center">No Active Recommendations</h5>
              </div>
            )}
          {suggestions.length > 0 &&
            !loadingSuggest &&
            selectedSuggestion === null && (
              <div className="card-body" ref={scrollRef}></div>
            )}
          {suggestions.length === 0 &&
            loadingSuggest &&
            selectedSuggestion === null && (
              <div className="card-body" ref={scrollRef}></div>
            )}
          <AnimatePresence mode="wait">
            {selectedSuggestion !== null ? (
              <motion.div
                key="detail"
                className="detail-view"
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "100%", opacity: 0 }}
                transition={{ duration: 0.3 }}
                style={{ overflow: "hidden" }}
              >
              <div>
                <button
                  className="px-[10px] py-0"
                  onClick={() => {
                    setSelectedSuggestion(null);
                    setSuggest(false);
                  }}
                >
                  <i className="fa fa-arrow-left" />
                </button>
            <label className="rec-container">
  <input type="checkbox" />
  <svg
    id="Glyph"
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29.845,17.099l-2.489,8.725C26.989,27.105,25.804,28,24.473,28H11c-0.553,0-1-0.448-1-1V13  
      c0-0.215,0.069-0.425,0.198-0.597l5.392-7.24C16.188,4.414,17.05,4,17.974,4C19.643,4,21,5.357,21,7.026V12h5.002  
      c1.265,0,2.427,0.579,3.188,1.589C29.954,14.601,30.192,15.88,29.845,17.099z" 
      id="XMLID_254_" />
    <path d="M7,12H3c-0.553,0-1,0.448-1,1v14c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1V13C8,12.448,7.553,12,7,12z   
      M5,25.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C6.5,24.828,5.828,25.5,5,25.5z" 
      id="XMLID_256_" />
  </svg>
</label>
</div>
                {loadingIndex === selectedSuggestion &&
                !answersMap[selectedSuggestion] ? (
                  <div className="zen-suggestions">
                    <div className="animation"></div>
                  </div>
                ) : (
                  <div className="zen-suggestions" ref={scrollRef}>
                    {(answersMap[selectedSuggestion] || []).map((msg, i) => (
                      <div
                        key={i}
                        className={`flex mb-2 ${
                          msg.sender === "user"
                            ? "justify-end"
                            : "justify-start"
                        }`}
                      >
                        <div
                          className={`p-2 w-full  rounded-2xl  ${
                            msg.sender === "user"
                              ? "rec-ubg text-black rounded-br-none"
                              : "rec-bg text-[#333] rounded-bl-none"
                          }`}
                        >
                          {msg.text && (
                            <div
                              className="mb-2 rec-fz"
                              dangerouslySetInnerHTML={{
                                __html: renderMessageHtml(msg.text),
                              }}
                            />
                          )}
                          {msg.meta?.groundedness && (
                            <div className="mt-3">
                              <span className="inline-block px-1 py-1 text-sm font-small text-green-800 rounded-1/2 shadow-sm">
                                Groundedness:{" "}
                                <strong className="text-sm">
                                  {msg.meta.groundedness}
                                </strong>
                              </span>
                            </div>
                          )}
                          {msg.meta?.sources && (
                            <div className="mt-2 flex">
                              <strong className="block m-1 font-normal">
                                Sources:
                              </strong>
                              <ul className="ml-1 space-y-1">
                                {msg.meta.sources.map((src, j) => (
                                  <li key={j}>
                                    <a
                                      href={src.sourcefile}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-600 underline inline-block px-1 py-1 text-sm font-medium rounded-1/2 shadow-sm"
                                    >
                                      {(() => {
                                        const url = new URL(src.sourcefile);
                                        const innerUri = new URLSearchParams(
                                          url.search
                                        ).get("uri"); // kb_knowledge.do?sys_id=KB0000027
                                        if (innerUri) {
                                          const innerParams =
                                            new URLSearchParams(
                                              innerUri.split("?")[1]
                                            );
                                          return (
                                            innerParams.get("sys_id") ||
                                            src.sourcefile
                                          );
                                        }
                                        return src.sourcefile;
                                      })()}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                    {loadingIndex === selectedSuggestion && (
                      <div className="flex mb-2 justify-start">
                        <div className="p-2 max-w-[90%] bg-gray-200 text-black rounded-2xl rounded-bl-none shadow">
                          <div className="animation"></div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </motion.div>
            ) : (
              <motion.ul
                key="list"
                className="suggestion-list"
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "-100%", opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                {suggestions.map((suggestion, i) => (
                  <li key={i} tabIndex={0} className="suggestion-item">
                    <div className="card" onClick={() => toggleDropdown(i)}>
                      <span className="card1">
                        <p>{suggestion}</p>
                        <div className="go-corner">
                          <div className="go-arrow">
                            <i className="fa fa-arrow-right text-[10px]" />
                          </div>
                        </div>
                      </span>
                    </div>
                  </li>
                ))}
              </motion.ul>
            )}
          </AnimatePresence>
          {loadingSuggest && (
            <div className="card skeleton-loader  suggestion-list">
              <div className="skeleton-line bg-slate-400  w-full"></div>
              <div className="skeleton-line bg-slate-400  w-full"></div>
              <div className="skeleton-line bg-slate-400  w-full"></div>
            </div>
          )}
          {!messageType && (
            <div
              className="card-footer px-0 p-0"
              style={{ background: "#fff" }}
            >
              <div
                className="chat-input-container d-flex align-items-center gap-2 w-100 rounded-pill px-0 py-0 shadow-sm"
                style={{ background: "#f9f9f9" }}
              >
                <div className="input">
                  <svg
                    className="svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5 6C11.3949 6.00006 11.2925 5.96705 11.2073 5.90565C11.1221 5.84425 11.0583 5.75758 11.0251 5.65792L10.7623 4.86908C10.6623 4.57101 10.4288 4.33629 10.13 4.23693L9.34102 3.97354C9.24166 3.94019 9.1553 3.87649 9.09411 3.79142C9.03292 3.70635 9 3.60421 9 3.49943C9 3.39465 9.03292 3.29252 9.09411 3.20745C9.1553 3.12238 9.24166 3.05867 9.34102 3.02532L10.13 2.76193C10.4282 2.66191 10.663 2.42852 10.7623 2.12979L11.0258 1.34094C11.0591 1.24161 11.1229 1.15526 11.2079 1.09409C11.293 1.03291 11.3952 1 11.5 1C11.6048 1 11.707 1.03291 11.7921 1.09409C11.8771 1.15526 11.9409 1.24161 11.9742 1.34094L12.2377 2.12979C12.2868 2.27697 12.3695 2.4107 12.4792 2.52041C12.589 2.63013 12.7227 2.71281 12.87 2.76193L13.659 3.02532C13.7583 3.05867 13.8447 3.12238 13.9059 3.20745C13.9671 3.29252 14 3.39465 14 3.49943C14 3.60421 13.9671 3.70635 13.9059 3.79142C13.8447 3.87649 13.7583 3.94019 13.659 3.97354L12.87 4.23693C12.5718 4.33696 12.337 4.57034 12.2377 4.86908L11.9742 5.65792C11.9411 5.75747 11.8774 5.84406 11.7923 5.90545C11.7072 5.96684 11.6049 5.99992 11.5 6Z"
                      fill="currentColor"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6 13C5.85133 13.0001 5.7069 12.9504 5.58969 12.859C5.47247 12.7675 5.38921 12.6395 5.35313 12.4952L5.12388 11.5745C4.91418 10.7391 4.26198 10.0868 3.42674 9.87703L2.50619 9.64774C2.36169 9.61194 2.23333 9.52878 2.14159 9.41151C2.04985 9.29425 2 9.14964 2 9.00075C2 8.85185 2.04985 8.70724 2.14159 8.58998C2.23333 8.47272 2.36169 8.38955 2.50619 8.35376L3.42674 8.12446C4.26198 7.91473 4.91418 7.2624 5.12388 6.427L5.35313 5.50629C5.38892 5.36176 5.47207 5.23338 5.58931 5.14162C5.70655 5.04986 5.85113 5 6 5C6.14887 5 6.29345 5.04986 6.41069 5.14162C6.52793 5.23338 6.61108 5.36176 6.64687 5.50629L6.87612 6.427C6.97865 6.83721 7.19071 7.21184 7.48965 7.51082C7.78858 7.80981 8.16313 8.02192 8.57326 8.12446L9.49381 8.35376C9.63831 8.38955 9.76667 8.47272 9.85841 8.58998C9.95015 8.70724 10 8.85185 10 9.00075C10 9.14964 9.95015 9.29425 9.85841 9.41151C9.76667 9.52878 9.63831 9.61194 9.49381 9.64774L8.57326 9.87703C8.16313 9.97957 7.78858 10.1917 7.48965 10.4907C7.19071 10.7897 6.97865 11.1643 6.87612 11.5745L6.64687 12.4952C6.61079 12.6395 6.52753 12.7675 6.41031 12.859C6.2931 12.9504 6.14867 13.0001 6 13Z"
                      fill="currentColor"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.5005 23C13.3376 23 13.1791 22.9469 13.049 22.8487C12.9189 22.7505 12.8243 22.6127 12.7795 22.456L11.9665 19.61C11.7915 18.9971 11.4631 18.4389 11.0124 17.9882C10.5616 17.5374 10.0035 17.209 9.39054 17.034L6.54454 16.221C6.38795 16.1761 6.25021 16.0815 6.15216 15.9514C6.05411 15.8214 6.00108 15.6629 6.00108 15.5C6.00108 15.3371 6.05411 15.1786 6.15216 15.0486C6.25021 14.9185 6.38795 14.8239 6.54454 14.779L9.39054 13.966C10.0035 13.791 10.5616 13.4626 11.0124 13.0118C11.4631 12.5611 11.7915 12.0029 11.9665 11.39L12.7795 8.544C12.8244 8.38741 12.919 8.24967 13.0491 8.15162C13.1792 8.05357 13.3376 8.00054 13.5005 8.00054C13.6634 8.00054 13.8219 8.05357 13.952 8.15162C14.0821 8.24967 14.1767 8.38741 14.2215 8.544L15.0345 11.39C15.2096 12.0029 15.538 12.5611 15.9887 13.0118C16.4394 13.4626 16.9976 13.791 17.6105 13.966L20.4565 14.779C20.6131 14.8239 20.7509 14.9185 20.8489 15.0486C20.947 15.1786 21 15.3371 21 15.5C21 15.6629 20.947 15.8214 20.8489 15.9514C20.7509 16.0815 20.6131 16.1761 20.4565 16.221L17.6105 17.034C16.9976 17.209 16.4394 17.5374 15.9887 17.9882C15.538 18.4389 15.2096 18.9971 15.0345 19.61L14.2215 22.456C14.1768 22.6127 14.0822 22.7505 13.9521 22.8487C13.822 22.9469 13.6635 23 13.5005 23Z"
                      fill="currentColor"
                    ></path>
                  </svg>

                  <input
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && isSuggest) {
                        e.preventDefault();
                        sendMessage();
                      }
                    }}
                    className="search"
                    type="text"
                    placeholder="What can I help you with?"
                  />
                </div>

                {isSuggest && (
                  <button
                    className="btn btn-dark btn-sm rounded-circle"
                    onClick={sendMessage}
                  >
                    <i className="fas fa-arrow-up text-white"></i>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {sidebarVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-3/4 max-w-4xl relative">
            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h4 className="text-sm font-semibold">{"📄 Document Preview"}</h4>
              <button
                onClick={closeSidebar}
                className="text-red-500 text-lg font-bold"
              >
                ✖
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              {selectedPdfUrl && (
                <iframe
                  style={{ height: "70vh" }}
                  src={selectedPdfUrl}
                  className="w-full rounded"
                  title="Document Preview"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
